export const LocationPresetTipType = {
  Percentage: 'percentage',
  Fixed: 'fixed',
} as const;

export type LocationPresetTipType =
  (typeof LocationPresetTipType)[keyof typeof LocationPresetTipType];
